const newDisplay = "💥NEW💥";

const biscuitOptions95 = [
  
  {
    name: "NDP Special - Flying Burger Balls",
    sku: "MIX-FBB-GIFT",
    popular: true,
    weight: 40,
    unit: "g",
    tooltip: "A mix of the classics!",
  },
  {
    name: "Biscuits - Bouncy Baby Balls",
    sku: "BAL-BAB-40",
    popular: true,
    weight: 40,
    unit: "g",
    tooltip: "Classic milky balls",
  },
  {
    name: "Biscuits - Flying Fish Biscuits",
    sku: "BIS-FLF-40",
    popular: true,
    weight: 40,
    unit: "g",
    tooltip: "We always grab a handful when we eat this",
  },
  {
    name: "Biscuits - Happy Pineapple Tarts",
    sku: "PAT-HAP-40",
    popular: true,
    weight: 40,
    unit: "g",
    tooltip: "Greeting you with a smile",
  },
  {
    name: "Biscuits - Seaweed Biscuits",
    sku: "BIS-SEA-40",
    popular: false,
    weight: 40,
    unit: "g",
    tooltip: "Sweet and salty seaweed taste",
  },
  {
    name: "Iced Gem - Burger Iced Gem",
    sku: "ICG-BUR-40",
    popular: false,
    weight: 40,
    unit: "g",
    tooltip: "If you love iced gem biscuits, you will love this",
  },
  {
    name: "Iced Gem - Nostalgic Iced Gem",
    sku: "ICG-TRA-40",
    popular: true,
    weight: 40,
    unit: "g",
    tooltip: "Classic iced gems",
  },
  {
    name: "Crackers - Butter Murukku Crackers",
    sku: "CRA-BMU-30",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Classic dal snack",
  },
  {
    name: "Crackers - Couch Potato Wheel Crackers",
    sku: "CRA-PWH-10",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "The wheels on the bus go potatoes..",
  },
  {
    name: "Crackers - Spicy Murukku Crackers",
    sku: "CRA-SMU-30",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Classic with a spice",
  },
  {
    name: "Crackers - Senbei Rice Crackers",
    sku: "RCRA-BBQ-30",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "BBQ flavoured rice cracker",
  },
  {
    name: "Crackers - Shredded Tapioca Fries",
    sku: "TAP-FRI-30",
    popular: false,
    weight: 30,
    unit: "g",
    tooltip: "Tapioca thin slices.",
  },
];

const biscuitOptions25 = [
  {
    name: "NDP Special - Flying Burger Balls",
    sku: "MIX-FBB-PARTY",
    popular: true,
    weight: 15,
    unit: "g",
    tooltip: "A mix of the classics!",
  },
  {
    name: "Biscuits - Bouncy Baby Balls",
    sku: "BAL-BAB-15",
    popular: true,
    weight: 15,
    unit: "g",
    tooltip: "Classic milky balls",
  },
  {
    name: "Biscuits - Flying Fish Biscuits",
    sku: "BIS-FLF-15",
    popular: true,
    weight: 15,
    unit: "g",
    tooltip: "We always grab a handful when we eat this",
  },
  {
    name: "Biscuits - Happy Pineapple Tarts",
    sku: "PAT-HAP-15",
    popular: true,
    weight: 15,
    unit: "g",
    tooltip: "Greeting you with a smile",
  },
  {
    name: "Biscuits - Seaweed Biscuits",
    sku: "BIS-SEA-15",
    popular: false,
    weight: 15,
    unit: "g",
    tooltip: "Sweet and salty seaweed taste",
  },
  {
    name: "Iced Gem - Burger Iced Gem",
    sku: "ICG-BUR-15",
    popular: false,
    weight: 15,
    unit: "g",
    tooltip: "If you love iced gem biscuits, you will love this",
  },
  {
    name: "Iced Gem - Nostalgic Iced Gem",
    sku: "ICG-TRA-15",
    popular: true,
    weight: 15,
    unit: "g",
    tooltip: "Classic iced gems",
  },
  {
    name: "Crackers - Butter Murukku Crackers",
    sku: "CRA-BMU-10",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Classic dal snack",
  },
  {
    name: "Crackers - Couch Potato Wheel Crackers",
    sku: "CRA-PWH-2",
    popular: false,
    weight: 2,
    unit: "g",
    tooltip: "The wheels on the bus go potatoes..",
  },
  {
    name: "Crackers - Spicy Murukku Crackers",
    sku: "CRA-SMU-10",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Classic with a spice",
  },
  {
    name: "Crackers - Senbei Rice Crackers",
    sku: "RCRA-BBQ-10",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "BBQ flavoured rice cracker",
  },
  {
    name: "Crackers - Shredded Tapioca Fries",
    sku: "TAP-FRI-10",
    popular: false,
    weight: 10,
    unit: "g",
    tooltip: "Tapioca thin slices.",
  },
];

const biscuitOptionsRetail = [
  {
    name: "Bouncy Baby Balls",
    sku: "BAL-BAB-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "Classic milky balls",
  },
  {
    name: "Burger Iced Gem",
    sku: "ICG-BUR-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "If you love iced gem biscuits, you will love this",
  },
  {
    name: "Butter Murukku Crackers",
    sku: "CRA-BMU-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Classic dal snack",
  },
  {
    name: "Flying Fish Biscuits",
    sku: "BIS-FLF-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "We always grab a handful when we eat this",
  },
  {
    name: "Happy Pineapple Tarts",
    sku: "PAT-HAP-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "Greeting you with a smile",
  },
  {
    name: "Kacang Puteh Medley",
    sku: "MIX-KAP-200",
    popular: true,
    weight: 200,
    unit: "g",
    tooltip: "Classic variety.",
  },
  {
    name: "Nostalgic Iced Gem",
    sku: "ICG-TRA-120",
    popular: true,
    weight: 120,
    unit: "g",
    tooltip: "Classic iced gems",
  },
  {
    name: "Satay Crunch Peanuts",
    sku: "PEA-SAT-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Garlicy goodness",
  },
  {
    name: "Seaweed Biscuits",
    sku: "BIS-SEA-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Sweet and salty seaweed taste",
  },
  {
    name: "Senbei Rice Crackers",
    sku: "RCRA-BBQ-100",
    popular: false,
    weight: 100,
    unit: "g",
    tooltip: "BBQ flavoured rice cracker",
  },
  {
    name: "Shredded Tapioca Fries",
    sku: "TAP-FRI-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Tapioca thin slices.",
  },
  {
    name: "Spicy Murukku Crackers",
    sku: "CRA-SMU-120",
    popular: false,
    weight: 120,
    unit: "g",
    tooltip: "Classic with a spice",
  },
];

const popularSnackOptions25 = [
  // {"name": "🏮CNY🏮 - Peanut Kok Zai","sku": "CNY-KOK-15","popular": true,"weight": 15,"unit": "g","tooltip": "Must have during Chinese New Year!",},
  // {
  //   name: "Honey Red Dates (Hari Raya Special)",
  //   sku: "DAT-HON-25",
  //   popular: true,
  //   weight: 25,
  //   unit: "g",
  //   tooltip: "Hari Raya Special",
  // },
  {
    name: "Berry Nutty Medley (Baked cashews, almonds, mulberries, raisins, cranberries)",
    sku: "MIX-BRN-25",
    popular: true,
    weight: 25,
    unit: "g",
    tooltip: "Baked cashews, almonds, mulberries, raisins, cranberries",
  },
  { name: "Juicy Apricots", sku: "APR-DRI-25", popular: true, weight: 25, unit: "g", tooltip: "Dried apricots" },
  {
    name: "Oishi Japanese Nuts Medley",
    sku: "MIX-JAP-20",
    popular: true,
    weight: 20,
    unit: "g",
    tooltip: "Mix of coated peanuts",
  },
  {
    name: "Sweet Mustard Soya Crisps",
    sku: "SOY-SMT-20",
    popular: true,
    weight: 20,
    unit: "g",
    tooltip: "Addictive sweet,complex, tangy flavour",
  },
  {
    name: "Aloha Medley (Mango, Apricot, Coconut, Apple Chia Seeds Pastilles)",
    sku: "MIX-ALO-20",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "Tropical fruits paradise!",
  },
  {
    name: "Crunchy Medley (Roasted cashews, baked almonds, hazelnuts)",
    sku: "MIX-CRU-25",
    popular: false,
    weight: 25,
    unit: "g",
    tooltip: "Roasted cashews, baked almonds, hazelnuts",
  },
  {
    name: "Crisp Crack Medley (Pretzels, Soya Crisps, Senbei, Snackanoodles, Seaweed Biscuits)",
    sku: "MIX-CRI-PARTY",
    popular: false,
    weight: 15,
    unit: "g",
    tooltip: "Crunch crunch and crunch, your gums won't like it but you sure do!",
  },
  {
    name: "Fantasy Medley (Chocolate Pretzels, Raisins & Candies)",
    sku: "MIX-FAN-20",
    popular: false,
    weight: 20,
    unit: "g",
    tooltip: "Sweet fantasy dreams..",
  },
  {
    name: "Jungle Medley (Salted Cashew, Peanuts, Macadamias, Pretzels, Soya Crisps)",
    sku: "MIX-JUN-PARTY",
    popular: false,
    weight: 25,
    unit: "g",
    tooltip: "If you are ever stuck in a jungle, these are your friends",
  },
  {
    name: "Super Berries Medley (Cranberries, goji berries, raisins, cherries)",
    sku: "MIX-BER-25",
    popular: false,
    weight: 25,
    unit: "g",
    tooltip: "Cranberries, goji berries, raisins, cherries",
  },
  {
    name: "Sour Candies Medley",
    sku: "MIX-CAN-25",
    popular: false,
    weight: 25,
    unit: "g",
    tooltip: "To cure your sweet tooth.",
  },
  {
    name: "Summer Fruits Medley (Raisins, apricots, banana chips)",
    sku: "MIX-SMF-25",
    popular: false,
    weight: 25,
    unit: "g",
    tooltip: "Raisins, apricots, banana chips",
  },
  // {"name": "Chocolate Ribbon Pretzels","sku": "PRE-CHO-20","popular": false,"weight": 20,"unit": "g","tooltip": "Chocolate coated pretzels",},
  // {"name": "Crunchy Medley (Roasted cashews, baked almonds, hazelnuts)","sku": "MIX-CRU-25","popular": false,"weight": 25,"unit": "g","tooltip": "Roasted cashews, baked almonds, hazelnuts",},
  // {"name": "Kacang Puteh Medley","sku": "MIX-KAP-25","popular": false,"weight": 25,"unit": "g","tooltip": "A mix of everything, a mix of blessings~",},
  // {"name": "Original Ribbon Pretzels","sku": "PRE-ORI-10","popular": false,"weight": 10,"unit": "g","tooltip": "Salted crunchy pretzels are hard to stop!",},
  // {"name": "Rich Chocolate Almonds","sku": "ALM-CHO-25","popular": false,"weight": 25,"unit": "g","tooltip": "Chocolate Coated Almonds",},
];

const popularSnackOptions95 = [
  // {"name": "🏮CNY🏮 - Peanut Kok Zai","sku": "CNY-KOK-30","popular": true,"weight": 30,"unit": "g","tooltip": "Must have during Chinese New Year!",},
  {
    name: "Berry Nutty Medley (Baked cashews, almonds, mulberries, raisins, cranberries)",
    sku: "MIX-BRN-95",
    popular: true,
    weight: 95,
    unit: "g",
    tooltip: "Baked cashews, almonds, mulberries, raisins, cranberries",
  },
  {
    name: "Juicy Apricots",
    sku: "APR-DRI-95",
    popular: true,
    weight: 95,
    unit: "g",
    tooltip: "Dried apricots",
    selected: true,
  },
  {
    name: "Oishi Japanese Nuts Medley",
    sku: "MIX-JAP-70",
    popular: true,
    weight: 70,
    unit: "g",
    tooltip: "Mix of coated peanuts",
    selected: true,
  },
  {
    name: "Sweet Mustard Soya Crisps",
    sku: "SOY-SMT-70",
    popular: true,
    weight: 70,
    unit: "g",
    tooltip: "Addictive sweet,complex, tangy flavour",
    selected: true,
  },
  {
    name: "Aloha Medley (Mango, Apricot, Coconut, Apple Chia Seeds Pastilles)",
    sku: "MIX-ALO-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "Tropical fruits paradise!",
  },
  {
    name: "Crunchy Medley (Roasted cashews, baked almonds, hazelnuts)",
    sku: "MIX-CRU-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "Roasted cashews, baked almonds, hazelnuts",
  },
  {
    name: "Crisp Crack Medley (Pretzels, Soya Crisps, Senbei, Snackanoodles, Seaweed Biscuits)",
    sku: "MIX-CRI-GIFT",
    popular: false,
    weight: 70,
    unit: "g",
    tooltip: "Crunch crunch and crunch, your gums won't like it but you sure do!",
  },
  {
    name: "Fantasy Medley (Chocolate Pretzels, Raisins & Candies)",
    sku: "MIX-FAN-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "Sweet fantasy dreams..",
  },
  {
    name: "Jungle Medley (Salted Cashew, Peanuts, Macadamias, Pretzels, Soya Crisps)",
    sku: "MIX-JUN-GIFT",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "If you are ever stuck in a jungle, these are your friends",
  },
  {
    name: "Super Berries Medley (Cranberries, goji berries, raisins, cherries)",
    sku: "MIX-BER-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "Cranberries, goji berries, raisins, cherries",
  },
  {
    name: "Sour Candies Medley",
    sku: "MIX-CAN-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "To cure your sweet tooth.",
  },
  {
    name: "Summer Fruits Medley (Raisins, apricots, banana chips)",
    sku: "MIX-SMF-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "Raisins, apricots, banana chips",
  },
];

const popularSnackOptions200 = [
  // {"name": "Xmas Special - Peppermint Dark Chocolate Chunks","sku": "CCH-PPM-200","popular": true,"weight": 200,"unit": "g","tooltip": "You will have a mouth full of chocolate with a pleasant cool mint aftertaste. Shiok~",},
  {
    name: "Berry Nutty Medley (Baked cashews, almonds, mulberries, raisins, cranberries)",
    sku: "MIX-BRN-200",
    popular: true,
    weight: 200,
    unit: "g",
    tooltip: "Baked cashews, almonds, mulberries, raisins, cranberries",
  },
  { name: "Juicy Apricots", sku: "APR-DRI-200", popular: true, weight: 200, unit: "g", tooltip: "Dried apricots" },
  {
    name: "Oishi Japanese Nuts",
    sku: "MIX-JAP-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "Mix of coated peanuts",
  },
  {
    name: "Sweet Mustard Soya Crisps",
    sku: "SOY-SMT-150",
    popular: true,
    weight: 150,
    unit: "g",
    tooltip: "Addictive sweet,complex, tangy flavour",
  },
  {
    name: "Aloha Medley (Mango, Aloe Vera, Coconut, Apple Chia Seeds Pastilles)",
    sku: "MIX-ALO-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Tropical fruits paradise!",
  },
  {
    name: "Crunchy Medley (Roasted cashews, baked almonds, hazelnuts)",
    sku: "MIX-CRU-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Roasted cashews, baked almonds, hazelnuts",
  },
  {
    name: "Crisp Crack Medley (Pretzels, Soya Crisps, Senbei, Snackanoodles, Seaweed Biscuits)",
    sku: "MIX-CRI-RET",
    popular: false,
    weight: 150,
    unit: "g",
    tooltip: "Crunch crunch and crunch, your gums won't like it but you sure do!",
  },
  {
    name: "Fantasy Medley (Chocolate Pretzels, Raisins & Candies)",
    sku: "MIX-FAN-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Sweet fantasy dreams..",
  },
  {
    name: "Jungle Medley (Salted Cashew, Peanuts, Macadamias, Pretzels, Soya Crisps)",
    sku: "MIX-JUN-RET",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "If you are ever stuck in a jungle, these are your friends",
  },
  {
    name: "Super Berries Medley (Cranberries, goji berries, raisins, cherries)",
    sku: "MIX-BER-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Cranberries, goji berries, raisins, cherries",
  },
  {
    name: "Sour Candies Medley",
    sku: "MIX-CAN-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "To cure your sweet tooth.",
  },
  {
    name: "Summer Fruits Medley (Raisins, apricots, banana chips)",
    sku: "MIX-SMF-200",
    popular: false,
    weight: 200,
    unit: "g",
    tooltip: "Raisins, apricots, banana chips",
  },
];

const cookieOptions25 = [
  {
    name: "Merlion Butter Cookies",
    sku: "COO-MER-15",
    weight: 15,
    unit: "g",
    tooltip: "Eating this reminds me of Home.",
  },
  {
    name: "Delightful Bangkit Cookies",
    sku: "COO-BAN-15",
    weight: 15,
    unit: "g",
    tooltip: "A taste of tradition.",
  },
  {
    name: "Chunky Peanut Cookies",
    sku: "COO-PEA-PARTY",
    weight: 25,
    unit: "g",
    tooltip: "Old school peanut cookies.",
  },
  {
    name: "Crunchy Cashew Cookies",
    sku: "COO-CAS-PARTY",
    weight: 25,
    unit: "g",
    tooltip: "Old school cashew cookies.",
  },
  {
    name: "Worthy Almond Biscotti (3 pieces)",
    sku: "WOR-ALMBIS-8",
    weight: 12,
    unit: "g",
    tooltip: "Munching this reminded me that I eat healthy.",
  },
  {
    name: "Worthy Coffee Butter Cookies (2 pieces)",
    sku: "WOR-COF-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "Legit Kopi Cookie",
  },
  {
    name: "Worthy Hazelnut Oat Cookies (1 cookie)",
    sku: "WOR-HAOCOO-9",
    weight: 9,
    unit: "g",
    tooltip: "Oat lovers need to try this.",
  },
  {
    name: "Worthy Macadamia Cookies (1 cookie)",
    sku: "WOR-MACCOO-9",
    weight: 9,
    unit: "g",
    tooltip: "The macadamia pieces add an extra dimension.",
  },
  {
    name: "Worthy Ondeh Ondeh Cookies (2 cookies)",
    sku: "WOR-OND-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "Coconut, gula melaka and pandan proves a deadly combi.",
    popular: true,
  },
  {
    name: "Worthy Osmanthus Cookies (1 cookie)",
    sku: "WOR-OSMAN-9",
    weight: 9,
    unit: "g",
    tooltip: "Sweet with a mild osmanthus flower fragrance",
  },
  {
    name: "Worthy Pecans Chocolate Chip Cookies (2 pieces)",
    sku: "WOR-PEC-PARTY",
    weight: 12,
    unit: "g",
    tooltip: "Who doesn't like chocolate chips? And the pecans balance the sweetness.",
    popular: true,
  },
  {
    name: "Worthy Pistachio Berry Biscotti (3 pieces)",
    sku: "WOR-PIBBIS-8",
    weight: 12,
    unit: "g",
    tooltip: "This. Is. Good.",
    popular: true,
  },
  {
    name: "Worthy Pistachio Cookies (1 cookie)",
    sku: "WOR-PISCOO-9",
    weight: 9,
    unit: "g",
    tooltip: "Our favourite!",
    
  },
];

const cookieOptions95 = [
  {
    name: "Merlion Butter Cookies",
    sku: "COO-MER-40",
    weight: 50,
    unit: "g",
    tooltip: "Eating this reminds me of Home.",
  },
  {
    name: "Delightful Bangkit Cookies",
    sku: "COO-BAN-40",
    weight: 50,
    unit: "g",
    tooltip: "A taste of tradition.",
  },
  {
    name: "Chunky Peanut Cookies",
    sku: "COO-PEA-PARTY",
    weight: 50,
    unit: "g",
    tooltip: "Old school peanut cookies.",
  },
  {
    name: "Crunchy Cashew Cookies",
    sku: "COO-CAS-PARTY",
    weight: 50,
    unit: "g",
    tooltip: "Old school cashew cookies.",
  },
  {
    name: "Worthy Almond Biscotti (8 pieces)",
    sku: "WOR-ALMBIS-32",
    weight: 32,
    unit: "g",
    tooltip: "Munching this reminded me that I eat healthy.",
  },
  {
    name: "Worthy Coffee Butter Cookies (8 pieces)",
    sku: "WOR-COF-GIFT",
    weight: 48,
    unit: "g",
    tooltip: "Legit Kopi Cookie",
  },
  {
    name: "Worthy Macadamia Cookies (4 cookies)",
    sku: "WOR-MACCOO-36",
    weight: 36,
    unit: "g",
    tooltip: "The macadamia pieces add an extra dimension.",
  },
  {
    name: "Worthy Ondeh Ondeh Cookies (8 cookies)",
    sku: "WOR-OND-GIFT",
    weight: 48,
    unit: "g",
    tooltip: "Coconut, gula melaka and pandan proves a deadly combi.",
    popular: true,
  },
  {
    name: "Worthy Osmanthus Cookies (4 cookies)",
    sku: "WOR-OSMAN-36",
    weight: 36,
    unit: "g",
    tooltip: "Sweet with a mild osmanthus flower fragrance",
  },
  { 
    name: "Worthy Pecans Chocolate Chip Cookies (8 pieces)",
    sku: "WOR-PEC-GIFT",
    weight: 48,
    unit: "g",
    tooltip: "Who doesn't like chocolate chips? And the pecans balance the sweetness.",
    popular: true,
  },
  {
    name: "Worthy Pistachio Berry Biscotti (8 pieces)",
    sku: "WOR-PIBBIS-32",
    weight: 32,
    unit: "g",
    tooltip: "This. Is. Good.",
    popular: true,
  },
  {
    name: "Worthy Pistachio Cookies (4 cookies)",
    sku: "WOR-PISCOO-36",
    weight: 36,
    unit: "g",
    tooltip: "Our favourite!",
  },
  {
    name: "Worthy Hazelnut Oat Cookies (4 cookies)",
    sku: "WOR-HAOCOO-36",
    weight: 36,
    unit: "g",
    tooltip: "Oat lovers need to try this.",
  },
];

const goodieBoxOptions = [
  {"name": "Worthy Osmanthus Pistachio Berry", "sku": "GBOX-ROY-100", "weight": 100, "unit": "g"},
  {"name": "Worthy Ondeh Coffee Butter", "sku": "GBOX-FRA-100", "weight": 100, "unit": "g"},
  {"name": "Worthy Macadamia Pistachio", "sku": "GBOX-NUT-100", "weight": 100, "unit": "g"},
  {"name": "Worthy Pecans Chocolate Chip Almond Biscotti", "sku": "GBOX-TASTY", "weight": 100, "unit": "g"},
  {"name": "Merlion Butter Cookies", "sku": "GBOX-MER-80", "weight": 80, "unit": "g"},
  {"name": "Aloha Medley", "sku": "GBOX-MIX-ALO", "weight": 150, "unit": "g"},
  {"name": "Cocoa Power Medley", "sku": "GBOX-MIX-CPO", "weight": 150, "unit": "g"},
  {"name": "Kacang Puteh Medley", "sku": "GBOX-MIX-KAP", "weight": 120, "unit": "g"},
  {"name": "Sour Candies Medley", "sku": "GBOX-MIX-CAN", "weight": 150, "unit": "g"},
  {"name": "Juicy Apricots", "sku": "GBOX-APR-DRI", "weight": 150, "unit": "g"},
];

const snackieBoxOptions = [
{"name": "Worthy Coffee Butter Cookies", "sku": "SBOX-WOR-COF", "weight": 180, "unit": "g"},
{"name": "Worthy Macadamia Cookies", "sku": "SBOX-WOR-MAC", "weight": 180, "unit": "g"},
{"name": "Worthy Ondeh Ondeh Cookies", "sku": "SBOX-WOR-OND", "weight": 180, "unit": "g"},
{"name": "Worthy Pecans Chocolate Chip Cookies", "sku": "SBOX-WOR-PEC", "weight": 180, "unit": "g"},
{"name": "Fruity Veggie Medley", "sku": "SBOX-MIX-FTV", "weight": 120, "unit": "g"},
{"name": "Supreme Brainy Medley", "sku": "SBOX-MIX-BRA", "weight": 250, "unit": "g"},
{"name": "Supreme Hearty Medley", "sku": "SBOX-MIX-HRT", "weight": 250, "unit": "g"},
{"name": "Supreme Honey Medley", "sku": "SBOX-MIX-HON", "weight": 220, "unit": "g"},
{"name": "Honey Brainy Pecans", "sku": "SBOX-PEC-HON", "weight": 220, "unit": "g"},
{"name": "Truly Veggie Medley", "sku": "SBOX-MIX-TRV", "weight": 120, "unit": "g"},
];

const cutieBoxOptions = [
  { name: "Berry Nutty Medley", sku: "CBOX-MIX-BRN", weight: 80, unit: "g" },
  { name: "Cocoa Power Medley", sku: "CBOX-MIX-CPO", weight: 70, unit: "g" },
  { name: "Healthy Medley", sku: "CBOX-MIX-HLT", weight: 70, unit: "g" },
  { name: "Oishi Japanese Nuts Medley", sku: "CBOX-MIX-JAP", weight: 50, unit: "g" },
  { name: "Rich Chocolate Almonds", sku: "CBOX-ALM-CHO", weight: 70, unit: "g" },
  { name: "Sour Candies Medley", sku: "CBOX-MIX-CAN", weight: 70, unit: "g" },
  { name: "Super Berries Medley", sku: "CBOX-MIX-BER", weight: 80, unit: "g" },
  { name: "Summer Fruits Medley", sku: "CBOX-MIX-SMF", weight: 80, unit: "g" },
  { name: "Sweet Mustard Soya Crisps", sku: "CBOX-SOY-SMT", weight: 50, unit: "g" },
  { name: "Worthy Osmanthus Cookies", sku: "CBOX-WOR-OSMAN", weight: 40, unit: "g" },
];

const hamperRetailPackOptions = [
{"name": "Crisp Crack Medley", "sku": "MIX-CRI-RET", "weight": 150, "unit": "g"},
{"name": "Jungle Medley", "sku": "MIX-JUN-RET", "weight": 200, "unit": "g"},
{"name": "Berry Nutty Medley", "sku": "MIX-BRN-200", "weight": 200, "unit": "g"},
{"name": "Oishi Japanese Nuts Medley", "sku": "MIX-JAP-150", "weight": 150, "unit": "g"},
{"name": "Sweet Mustard Soya Crisps", "sku": "SOY-SMT-150", "weight": 150, "unit": "g"},
{"name": "Chocolate Ribbon Pretzels", "sku": "PRE-CHO-150", "weight": 150, "unit": "g"},
{"name": "Peanut Butter Shell Pretzels", "sku": "PRE-PBS-150", "weight": 150, "unit": "g"},
{"name": "Super Berries Medley", "sku": "MIX-BER-200", "weight": 200, "unit": "g"},
]

const remedyOptions = [
  {
    name: "Remedy - Mango Passion Kombucha",
    sku: "REM-MANPAS-250",
    popular: false,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
  { name: "Remedy - Wild Berry Kombucha", sku: "REM-WILBER-250", popular: false, weight: 250, unit: "ml", tooltip: "" },
  {
    name: "Remedy - Raspberry Lemonade Kombucha",
    sku: "REM-RASLEM-250",
    popular: true,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Remedy - Orange Squeeze Kombucha",
    sku: "REM-ORASQU-250",
    popular: true,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
];

const gryphonOptions = [
  {
    name: "Gryphon - Chamomile Dream with Apple",
    sku: "GRY-CDA-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Earl Grey Lavender Tea with Strawberry",
    sku: "GRY-EGS-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Hanami with White Peach",
    sku: "GRY-HAN-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Osmanthus Sencha with Passionfruit",
    sku: "GRY-OSP-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Gryphon - Pearl of the Orient with Lychee",
    sku: "GRY-POL-300",
    popular: true,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
];

const dashOptions = [
  { name: "Dash - Cucumber Sparkling Water", sku: "DAS-CUC-300", popular: false, weight: 300, unit: "ml", tooltip: "" },
  { name: "Dash - Lime Sparkling Water", sku: "DAS-LIM-300", popular: false, weight: 300, unit: "ml", tooltip: "" },
  { name: "Dash - Peach Sparkling Water", sku: "DAS-PEA-300", popular: true, weight: 300, unit: "ml", tooltip: "" },
  {
    name: "Dash - Raspberry Sparkling Water",
    sku: "DAS-RAS-300",
    popular: false,
    weight: 300,
    unit: "ml",
    tooltip: "",
  },
];

const sodalyOptions = [
  {
    name: "Sodaly - Yuzu Lemon Prebiotic Soda",
    sku: "SOD-YUZ-250",
    popular: false,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
  { name: "Sodaly - Guava Prebiotic Soda", sku: "SOD-GUA-250", popular: false, weight: 250, unit: "ml", tooltip: "" },
  {
    name: "Sodaly - Passionfruit Prebiotic Soda",
    sku: "SOD-PAS-250",
    popular: false,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
  {
    name: "Sodaly - Lemon Lime Bitters Prebiotic Soda",
    sku: "SOD-LEM-250",
    popular: false,
    weight: 250,
    unit: "ml",
    tooltip: "",
  },
];

const healthyDrinkOptions = remedyOptions.concat(gryphonOptions).concat(dashOptions).concat(sodalyOptions); 

const surpriseMe = [
  { name: "Surprise Me!", sku: "SURPRISE-DRINK-", popular: false, unit: "ml", tooltip: "Randomness is beauty" },
];

const rudeHealthOptions = [
  {
    name: "Rude Health - Ultimate Almond Drink",
    sku: "RUH-ULTALM-1K",
    popular: true,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Almond Drink",
    sku: "RUH-ORGALM-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Cashew Drink",
    sku: "RUH-ORGCAS-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Coconut Drink",
    sku: "RUH-ORGCOC-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
  {
    name: "Rude Health - Organic Hazelnut Drink",
    sku: "RUH-ORGHAZ-1K",
    popular: false,
    weight: 1,
    unit: "L",
    tooltip: "",
  },
];

const allSnackOptions = [
  { name: "Almonds - Diamond Almonds", sku: "ALM-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Almonds - Diamond Baked Almonds", sku: "ALM-BAK-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Almonds - Honey Butter Almonds", sku: "ALM-HON-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Almonds - Rich Chocolate Almonds", sku: "ALM-CHO-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Apricots - Juicy Apricots", sku: "APR-DRI-95", popular: true, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Apricots - Juicy Natural Apricot (No preservative)",
    sku: "APR-BLK-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Blackcurrants - Superfruit Blackcurrants",
    sku: "BCU-DRI-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Blueberries - Summer Blueberries", sku: "BLU-DRI-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Brazil Nuts - Zumba Baked Brazil Nuts",
    sku: "BRA-BAK-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Brazil Nuts - Zumba Brazil Nuts", sku: "BRA-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Broad Beans - Fava Broad Beans (Roasted)",
    sku: "BRO-ROA-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Broad Beans - Satay Broad Beans", sku: "BRO-SAT-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Cashews - Honey Butter Cashews", sku: "CAS-HON-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Cashews - Satay Sunkissed Cashews", sku: "CAS-SAT-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Cashews - Smiley Baked Cashews", sku: "CAS-BAK-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Cashews - Smiley Cashews", sku: "CAS-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Cashews - Sunkissed Cashews", sku: "CAS-ROA-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Cashews - Vietnam Sunkissed Cashews",
    sku: "CAS-VNR-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Cherries - Cheery Cherries", sku: "CHR-DRI-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Chewy Nougats - Berry Nutty Chewy Nougats",
    sku: "CNO-BRN-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Chewy Nougats - Chocolate Apricots Chewy Nougats",
    sku: "CNO-CHA-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Chewy Nougats - Salted Caramel Chewy Nougats",
    sku: "CNO-STC-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Chewy Nougats - Very Nutty Chewy Nougats",
    sku: "CNO-VRN-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Crackers - Senbei Rice Crackers", sku: "RCRA-BBQ-70", popular: false, weight: 70, unit: "g", tooltip: "" },
  { name: "Cranberries - Ruby Cranberries", sku: "CRA-DRI-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Figs - Go Big Natural Figs", sku: "FIG-TNA-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Figs - Go Mission Figs", sku: "FIG-MDR-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Green Peas - Shiok Wasabi Green Peas",
    sku: "GPE-WAS-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Hazelnuts - Chocolatey Baked Hazelnuts",
    sku: "HAZ-BAK-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Hazelnuts - Chocolatey Hazelnuts", sku: "HAZ-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Japanese Nuts - Oishi Japanese Nuts", sku: "MIX-JAP-70", popular: true, weight: 70, unit: "g", tooltip: "" },
  { name: "Jumble - Cheesy BBQ Jumble", sku: "JUM-CBB-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Jumble - Sweet Wasabi Jumble", sku: "JUM-SWA-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Lotus Seeds - Tangy Lotus Seeds", sku: "LOS-ROA-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Macadamias - Abalone Creamy Macadamia",
    sku: "MAC-ABA-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Macadamias - Creamy Baked Macadamias (Halves)",
    sku: "MAC-BAH-95",
    popular: true,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Macadamias - Creamy Macadamias", sku: "MAC-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Macadamias - Honey Creamy Macadamias",
    sku: "MAC-HON-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Macadamias - Rich Chocolate Macadamias",
    sku: "MAC-CHO-95",
    popular: true,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Mango - Tango Mango", sku: "MAN-DRI-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Antioxidants Medley", sku: "MIX-ANT-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Bar Snacks medley", sku: "MIX-BSN-70", popular: false, weight: 70, unit: "g", tooltip: "" },
  { name: "Medley - Berry Nutty Medley", sku: "MIX-BRN-95", popular: true, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Cocoa Power Medley", sku: "MIX-CPO-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Crunchy Medley", sku: "MIX-CRU-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Healthy Medley", sku: "MIX-HLT-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Kacang Puteh Medley", sku: "MIX-KAP-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Supreme Brainy Medley", sku: "MIX-BRA-95", popular: true, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Supreme Hearty Medley", sku: "MIX-HRT-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Supreme Ketogenic Medley", sku: "MIX-KET-95", popular: true, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Supreme Popular Medley", sku: "MIX-POP-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Trail Medley", sku: "MIX-TRA-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Truly Veggie Medley", sku: "MIX-TRV-50", popular: false, weight: 50, unit: "g", tooltip: "" },
  { name: "Mulberries - Bushy Mulberries", sku: "MUL-DRI-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Pastilles - Apple Chia Seeds Pastilles",
    sku: "PAS-ACS-70",
    popular: false,
    weight: 70,
    unit: "g",
    tooltip: "",
  },
  { name: "Peanuts - Anchovies Peanuts", sku: "PEA-ANC-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Peanuts - Garlicky peanuts", sku: "PEA-GAR-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Peanuts - Honey Glazed Peanuts", sku: "PEA-HON-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Peanuts - Mala Cajun peanuts", sku: "PEA-CAJ-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Peanuts - Satay Sunkissed Peanuts", sku: "PEA-SAT-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Peanuts - Shiok Salted Egg Peanuts", sku: "PEA-SAE-70", popular: false, weight: 70, unit: "g", tooltip: "" },
  {
    name: "Peanuts - Sunkissed Peanuts (Salted without skin)",
    sku: "PEA-ROA-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Pecans - Brainy Baked Pecans", sku: "PEC-BAK-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Pecans - Brainy Pecans", sku: "PEC-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Pecans - Honey Brainy Pecans", sku: "PEC-HON-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Pine Nuts - Xmas Pine Nuts", sku: "PIN-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Pistachio Kernels - Power Baked Pistachio Kernels",
    sku: "PIK-BAK-95",
    popular: true,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Pistachio Kernels - Power Pistachio Kernels",
    sku: "PIK-RAW-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Pistachios - Power Baked Pistachios",
    sku: "PIS-BAK-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  { name: "Pistachios - Power Pistachios", sku: "PIS-RAW-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Pretzels - Chocolate Ribbon Pretzels",
    sku: "PRE-CHO-70",
    popular: false,
    weight: 70,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Pretzels - Original Ribbon Pretzels",
    sku: "PRE-ORI-70",
    popular: false,
    weight: 70,
    unit: "g",
    tooltip: "",
  },
  { name: "Raisins - Aurora Raisins (Green)", sku: "RAI-GRN-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Raisins - Midnight Raisins (Black)", sku: "RAI-BLK-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Raisins - Party Chocolate Raisins", sku: "RAI-CHO-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Raisins - Party Yoghurt Raisins", sku: "RAI-YOG-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  {
    name: "Raisins - Sunshine Jumbo Raisins (Yellow)",
    sku: "RAI-YELJ-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Raisins - Sunshine Raisins (Yellow)",
    sku: "RAI-YEL-95",
    popular: false,
    weight: 95,
    unit: "g",
    tooltip: "",
  },
  {
    name: "Soya Crisps - Lemon Paprika Soya Crisps",
    sku: "SOY-LMP-70",
    popular: false,
    weight: 70,
    unit: "g",
    tooltip: "",
  },
  { name: "Soya Crisps - Original Soya Crisps", sku: "SOY-ORI-70", popular: false, weight: 70, unit: "g", tooltip: "" },
  {
    name: "Soya Crisps - Sweet Mustard Soya Crisps",
    sku: "SOY-SMT-70",
    popular: true,
    weight: 70,
    unit: "g",
    tooltip: "",
  },
  { name: "Walnuts - Honey Sweet Walnuts", sku: "WAL-HON-70", popular: false, weight: 70, unit: "g", tooltip: "" },
  { name: "Walnuts - Squirrel Baked Walnuts", sku: "WAL-BAK-70", popular: false, weight: 70, unit: "g", tooltip: "" },
  { name: "Walnuts - Squirrel Walnuts", sku: "WAL-RAW-70", popular: false, weight: 70, unit: "g", tooltip: "" },
  { name: "Wolfberries - Goji Wolfberries", sku: "GOJ-DRI-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Super Berries Medley", sku: "MIX-BER-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Medley - Summer Fruits Medley", sku: "MIX-SMF-95", popular: false, weight: 95, unit: "g", tooltip: "" },
  { name: "Peanuts - Nihon Seaweed Peanuts", sku: "PEA-NIS-95", popular: false, weight: 95, unit: "g", tooltip: "" },
];

const mooncakeFlavours = [
  { name: "Macadamia With Lotus Paste", sku: "MNC-MAC-170", weight: 170, unit: "g" },
  { name: "Mixed Nuts With Chicken Ham", sku: "MNC-MXN-170", weight: 170, unit: "g", popular: true },
  { name: "Double Yolk With Lotus Paste", sku: "MNC-DBY-170", weight: 170, unit: "g", popular: true },
  { name: "White Coffee with Melon Seeds", sku: "MNC-COF-170", weight: 170, unit: "g" },
];

const deepavaliSnacks200 = [
  { name: "Butter Murukku Crackers", sku: "CRA-BMU-120", weight: 120, unit: "g", popular: true },
  { name: "Spicy Murukku Crackers", sku: "CRA-SMU-120", weight: 120, unit: "g" },
  { name: "Star Murukku Crackers", sku: "CRA-STA-RET", weight: 120, unit: "g", popular: true },
  { name: "Round Murukku Crackers", sku: "CRA-ROU-RET", weight: 120, unit: "g" },
  { name: "Aloha Medley", sku: "MIX-ALO-200", weight: 200, unit: "g" },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-200", weight: 200, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-200", weight: 200, unit: "g" },
  { name: "Fantasy Medley", sku: "MIX-FAN-200", weight: 200, unit: "g" },
  { name: "Juicy Apricots", sku: "APR-DRI-200", weight: 200, unit: "g" },
  { name: "Kacang Puteh Medley", sku: "MIX-KAP-200", weight: 200, unit: "g", popular: true },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-200", weight: 200, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-200", weight: 200, unit: "g" },
];

const deepavaliSnacks95 = [
  { name: "Butter Murukku Crackers", sku: "CRA-BMU-30", weight: 30, unit: "g", popular: true },
  { name: "Spicy Murukku Crackers", sku: "CRA-SMU-30", weight: 30, unit: "g" },
  { name: "Star Murukku Crackers", sku: "CRA-STA-GIFT", weight: 30, unit: "g", popular: true },
  { name: "Round Murukku Crackers", sku: "CRA-ROU-GIFT", weight: 30, unit: "g" },
  { name: "Aloha Medley", sku: "MIX-ALO-95", weight: 95, unit: "g" },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-95", weight: 95, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-95", weight: 95, unit: "g" },
  { name: "Fantasy Medley", sku: "MIX-FAN-95", weight: 95, unit: "g" },
  { name: "Juicy Apricots", sku: "APR-DRI-95", weight: 95, unit: "g" },
  { name: "Kacang Puteh Medley", sku: "MIX-KAP-95", weight: 95, unit: "g", popular: true },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-95", weight: 95, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-95", weight: 95, unit: "g" },
];

const deepavaliSnacks25 = [
  { name: "Butter Murukku Crackers", sku: "CRA-BMU-10", weight: 10, unit: "g", popular: true },
  { name: "Spicy Murukku Crackers", sku: "CRA-SMU-10", weight: 10, unit: "g" },
  { name: "Star Murukku Crackers", sku: "CRA-STA-PARTY", weight: 10, unit: "g", popular: true },
  // {"name": "Round Murukku Crackers", "sku": "CRA-ROU-PARTY", "weight": 10, "unit": "g"},
  { name: "Aloha Medley", sku: "MIX-ALO-20", weight: 20, unit: "g" },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-25", weight: 25, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-25", weight: 25, unit: "g" },
  { name: "Fantasy Medley", sku: "MIX-FAN-25", weight: 25, unit: "g" },
  { name: "Juicy Apricots", sku: "APR-DRI-25", weight: 25, unit: "g" },
  { name: "Kacang Puteh Medley", sku: "MIX-KAP-25", weight: 25, unit: "g", popular: true },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-25", weight: 25, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-20", weight: 20, unit: "g" },
];

const happySnacks25 = [
  { name: "Berry Nutty Medley", sku: "MIX-BRN-25", weight: 25, unit: "g" },
  { name: "Chocolate Ribbon Pretzels", sku: "PRE-CHO-20", weight: 20, unit: "g" },
  { name: "Crunchy Medley", sku: "MIX-CRU-25", weight: 25, unit: "g" },
  { name: "Juicy Apricots", sku: "APR-DRI-25", weight: 25, unit: "g" },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-20", weight: 20, unit: "g" },
  { name: "Organic Chocolate Granola", sku: "GRA-OCH-20", weight: 20, unit: "g" },
  { name: "Salted Caramel Chewy Nougats", sku: "CNO-STC-25", weight: 25, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-25", weight: 25, unit: "g" },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-25", weight: 25, unit: "g" },
  { name: "Super Berries Medley", sku: "MIX-BER-25", weight: 25, unit: "g" },
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-20", weight: 20, unit: "g" },
  { name: "Worthy Pistachio Berry Biscotti", sku: "WOR-PIBBIS-8", weight: 8, unit: "g" },
];

const happySnacks95 = [
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-70", weight: 70, unit: "g", popular: true },
  { name: "Juicy Apricots", sku: "APR-DRI-95", weight: 95, unit: "g", popular: true },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-70", weight: 70, unit: "g", popular: true },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-95", weight: 95, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-95", weight: 95, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-95", weight: 95, unit: "g" },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-95", weight: 95, unit: "g" },
  { name: "Super Berries Medley", sku: "MIX-BER-95", weight: 95, unit: "g" },
  { name: "Chocolate Ribbon Pretzels", sku: "PRE-CHO-70", weight: 70, unit: "g" },
  { name: "Organic Chocolate Granola", sku: "GRA-OCH-70", weight: 70, unit: "g" },
  { name: "Worthy Pistachio Berry Biscotti", sku: "WOR-PIBBIS-32", weight: 32, unit: "g" },
  { name: "Salted Caramel Chewy Nougats", sku: "CNO-STC-95", weight: 95, unit: "g" },
];

const happySnacks200 = [
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-150", weight: 150, unit: "g", popular: true },
  { name: "Juicy Apricots", sku: "APR-DRI-200", weight: 200, unit: "g", popular: true },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-150", weight: 150, unit: "g", popular: true },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-200", weight: 200, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-200", weight: 200, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-200", weight: 200, unit: "g" },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-200", weight: 200, unit: "g" },
  { name: "Super Berries Medley", sku: "MIX-BER-200", weight: 200, unit: "g" },
  { name: "Chocolate Ribbon Pretzels", sku: "PRE-CHO-150", weight: 150, unit: "g" },
  { name: "Organic Chocolate Granola", sku: "GRA-OCH-150", weight: 150, unit: "g" },
  { name: "Worthy Pistachio Berry Biscotti", sku: "WOR-PIBBIS-120", weight: 120, unit: "g" },
  { name: "Salted Caramel Chewy Nougats", sku: "CNO-STC-200", weight: 200, unit: "g" },
];

const glitterBox95 = [
  { name: "Berry Nutty Medley", sku: "MIX-BRN-95", weight: 95, unit: "g", popular: true },
  { name: "Juicy Apricots", sku: "APR-DRI-95", weight: 95, unit: "g", popular: true },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-70", weight: 70, unit: "g", popular: true },
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-70", weight: 70, unit: "g", popular: true },
  { name: "Aloha Medley", sku: "MIX-ALO-95", weight: 95, unit: "g" },
  { name: "Cinnamon Pecans Granola", sku: "GRA-CNP-95", weight: 95, unit: "g" },
  { name: "Crunchy Medley", sku: "MIX-CRU-95", weight: 95, unit: "g" },
  { name: "Crisp Crack Medley", sku: "MIX-CRI-GIFT", weight: 70, unit: "g" },
  { name: "Fantasy Medley", sku: "MIX-FAN-95", weight: 95, unit: "g" },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-95", weight: 95, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-95", weight: 95, unit: "g", popular: true },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-95", weight: 95, unit: "g" },
];

const glitterBox200 = [
  { name: "Berry Nutty Medley", sku: "MIX-BRN-200", weight: 200, unit: "g", popular: true },
  { name: "Juicy Apricots", sku: "APR-DRI-200", weight: 200, unit: "g", popular: true },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-150", weight: 150, unit: "g", popular: true },
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-150", weight: 150, unit: "g", popular: true },
  { name: "Aloha Medley", sku: "MIX-ALO-200", weight: 200, unit: "g" },
  { name: "Cinnamon Pecans Granola", sku: "GRA-CNP-200", weight: 200, unit: "g" },
  { name: "Crunchy Medley", sku: "MIX-CRU-200", weight: 200, unit: "g" },
  { name: "Crisp Crack Medley", sku: "MIX-CRI-GIFT", weight: 150, unit: "g" },
  { name: "Fantasy Medley", sku: "MIX-FAN-200", weight: 200, unit: "g" },
  { name: "Rich Chocolate Almonds", sku: "ALM-CHO-200", weight: 200, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-200", weight: 200, unit: "g", popular: true },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-200", weight: 200, unit: "g" },
];

const bestMomDad200 = [
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-150", weight: 150, unit: "g", popular: true },
  { name: "Juicy Apricots", sku: "APR-DRI-200", weight: 200, unit: "g", popular: true },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-150", weight: 150, unit: "g", popular: true },
  { name: "Berry Nutty Medley", sku: "MIX-BRN-200", weight: 200, unit: "g", popular: true },
  { name: "Crunchy Medley", sku: "MIX-CRU-200", weight: 200, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-200", weight: 200, unit: "g" },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-200", weight: 200, unit: "g" },
  { name: "Super Berries Medley", sku: "MIX-BER-200", weight: 200, unit: "g" },
  { name: "Chocolate Ribbon Pretzels", sku: "PRE-CHO-150", weight: 150, unit: "g" },
  { name: "Organic Chocolate Granola", sku: "GRA-OCH-150", weight: 150, unit: "g" },
  { name: "Worthy Pistachio Berry Biscotti", sku: "WOR-PIBBIS-120", weight: 120, unit: "g" },
  { name: "Salted Caramel Chewy Nougats", sku: "CNO-STC-200", weight: 200, unit: "g" },
];

const hariRayaSpecials = [
  { name: "Colourful Donut Cookies", sku: "RAYA-COO-DON", weight: 300, unit: "g", popular: false },
  { name: "Lazat Cornflake Cookies", sku: "RAYA-COO-COR", weight: 400, unit: "g", popular: false },
  { name: "Pandan Makmur Cookies", sku: "RAYA-PMAK-300", weight: 300, unit: "g", popular: true },
  { name: "Pandan Pineapple Tarts", sku: "RAYA-PPIN-300", weight: 300, unit: "g", popular: true },
];

// to delete after apr 2025 if not in use
const hariRayaSnacks200 = [
  { name: "Bushy Mulberries", sku: "MUL-DRI-200", weight: 200, unit: "g" },
  { name: "Crunchy Medley", sku: "MIX-CRU-200", weight: 200, unit: "g", popular: true },
  { name: "Honey Red Dates", sku: "DAT-HON-200", weight: 200, unit: "g", popular: true },
  { name: "Go Big Natural Figs", sku: "FIG-TNA-200", weight: 200, unit: "g", popular: true },
  { name: "Juicy Apricots", sku: "APR-DRI-200", weight: 200, unit: "g", popular: true },
  { name: "Kacang Puteh Medley", sku: "MIX-KAP-200", weight: 200, unit: "g" },
  { name: "Nihon Seaweed Peanuts", sku: "PEA-NIS-200", weight: 200, unit: "g" },
  { name: "Nostalgic Iced Gem", sku: "ICG-TRA-120", weight: 120, unit: "g" },
  { name: "Organic Cinnamon Granola", sku: "GRA-OCI-150", weight: 150, unit: "g" },
  { name: "Satay Wasabi Peanuts", sku: "PEA-SWS-200", weight: 200, unit: "g" },
  { name: "Smiley Baked Cashews", sku: "CAS-BAK-200", weight: 200, unit: "g" },
  { name: "Sunshine Jumbo Raisins", sku: "RAI-YELJ-200", weight: 200, unit: "g" },
];

const nutsAboutYouSnacks95 = [
  { name: "Berry Nutty Medley", sku: "MIX-BRN-95", weight: 95, unit: "g" },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-70", weight: 70, unit: "g" },
  { name: "Organic Chocolate Granola", sku: "GRA-OCH-70", weight: 70, unit: "g" },
  { name: "Raspberry Dark Chocolate Almonds", sku: "ALM-RDC-95", weight: 95, unit: "g", popular: true },
  { name: "Salted Caramel Chewy Nougats", sku: "CNO-STC-95", weight: 95, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-95", weight: 95, unit: "g", popular: true },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-95", weight: 95, unit: "g" },
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-70", weight: 70, unit: "g", popular: true },
  { name: "Worthy Almond Biscotti", sku: "WOR-ALMBIS-32", weight: 32, unit: "g", popular: true },
  { name: "Worthy Chocolate Sprinkle Cookies", sku: "WOR-CSPCOO-36", weight: 36, unit: "g" },
  { name: "Worthy Macadamia Cookies", sku: "WOR-MACCOO-36", weight: 36, unit: "g" },
  { name: "Worthy Pistachio Berry Biscotti", sku: "WOR-PIBBIS-32", weight: 32, unit: "g" },
];

const nutsAboutYouSnacks200 = [
  { name: "Berry Nutty Medley", sku: "MIX-BRN-200", weight: 200, unit: "g" },
  { name: "Oishi Japanese Nuts Medley", sku: "MIX-JAP-150", weight: 150, unit: "g" },
  { name: "Organic Chocolate Granola", sku: "GRA-OCH-150", weight: 150, unit: "g" },
  { name: "Raspberry Dark Chocolate Almonds", sku: "ALM-RDC-200", weight: 200, unit: "g", popular: true },
  { name: "Salted Caramel Chewy Nougats", sku: "CNO-STC-200", weight: 200, unit: "g" },
  { name: "Sour Candies Medley", sku: "MIX-CAN-200", weight: 200, unit: "g", popular: true },
  { name: "Summer Fruits Medley", sku: "MIX-SMF-200", weight: 200, unit: "g" },
  { name: "Sweet Mustard Soya Crisps", sku: "SOY-SMT-150", weight: 150, unit: "g", popular: true },
  { name: "Worthy Almond Biscotti", sku: "WOR-ALMBIS-120", weight: 120, unit: "g", popular: true },
  { name: "Worthy Chocolate Sprinkle Cookies", sku: "WOR-CSPCOO-120", weight: 120, unit: "g" },
  { name: "Worthy Macadamia Cookies", sku: "WOR-MACCOO-120", weight: 120, unit: "g" },
  { name: "Worthy Pistachio Berry Biscotti", sku: "WOR-PIBBIS-120", weight: 120, unit: "g" },
];

const snackConeOptions = [
  { name: "Kacang Puteh Medley", sku: "CONE-MIX-KAP", weight: 70, unit: "g" },
  { name: "Magical Jellybeans Candies", sku: "CONE-CAN-MAG", weight: 70, unit: "g" },
  { name: "Oishi Japanese Nuts Medley", sku: "CONE-MIX-JAP", weight: 40, unit: "g" },
  { name: "Sour Candies Medley", sku: "CONE-MIX-CAN", weight: 70, unit: "g" },
  { name: "Sweet Mustard Soya Crisps", sku: "CONE-SOY-SMT", weight: 40, unit: "g" },
];

const customMedleyOptions = [
  { name: "Baked Almonds", isHalfPortion: false, unit: "g" },
  { name: "Baked Cashew", isHalfPortion: false, unit: "g" },
  { name: "Roasted Cashew", isHalfPortion: false, unit: "g" },
  { name: "Baked Walnuts", isHalfPortion: false, unit: "g" },
  { name: "Baked Hazelnuts", isHalfPortion: false, unit: "g" },
  { name: "Baked Pecans", isHalfPortion: false, unit: "g" },
  { name: "Dried Cranberries", isHalfPortion: false, unit: "g" },
  { name: "Black Raisins", isHalfPortion: false, unit: "g" },
  { name: "Green Raisin", isHalfPortion: false, unit: "g" },
  { name: "Jumbo Yellow Raisins", isHalfPortion: false, unit: "g" },
  { name: "Honey Red Dates", isHalfPortion: false, unit: "g" },
  { name: "Go Big Natural Figs", isHalfPortion: false, unit: "g" },
  { name: "Original Soya Crisps", isHalfPortion: false, unit: "g" },
  { name: "Baked Pistachio Kernels (Premium half portion)", isHalfPortion: true, unit: "g" },
  { name: "Baked Macadamia (Halves) (Premium half portion)", isHalfPortion: true, unit: "g" },
  { name: "Baked Brazil Nuts (Premium half portion)", isHalfPortion: true, unit: "g" },
  { name: "Raw Pine Nuts (Premium half portion)", isHalfPortion: true, unit: "g" },
];

const popularDrinkOptions = remedyOptions
  .concat(gryphonOptions)
  .concat(dashOptions)
  .concat(sodalyOptions)
  .concat(surpriseMe);

const yesOrNo = [
  { name: "Yes", sku: "yes" },
  { name: "No", sku: "no" },
];

const icedGemKeyChainOptions = [
  { name: "Blue Iced Gem Keychain", sku: "SF-GEM-BKEY" },
  { name: "Pink Iced Gem Keychain", sku: "SF-GEM-PKEY" },
];

const bearBottleOptions = [
  { name: "Magical Jellybeans Candies in Blue Bear Bottle", sku: "BEAR-CAN-MAG" },
  { name: "Sweet Peach Candies in Pink Bear bottle", sku: "BEAR-CAN-SWP" },
];

const imageOptions = [
  {
    name: "Happy Deepavali A",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Deepavali_2025_Label_A.webp?v=1757570220"
  },
  {
    name: "Happy Deepavali B",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Deepavali_2025_Label_B.webp?v=1757570227"
  },
  {
    name: "Happy Snacking Emoji",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Happy_Snacking_Emoji.webp?v=1748956357",
  },
  {
    name: "Happy Snacking Spring",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Happy_Snacking_Spring.webp?v=1749113622",
  },
  {
    name: "Thank You Flowers",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Thank_You_Flowers.webp?v=1748956356",
  },
  {
    name: "Thank You Dark Floral",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Thank_you_Dark_Floral.webp?v=1749113621",
  },
  {
    name: "Plain",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Plain-no-label.jpg?v=1692951298",
  },
];

const weddingImageOptions = [
  {
    name: "Shuang Xi Modern",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/shuang-xi.jpg?v=1694483679",
  },
  {
    name: "Shuang Xi Traditional",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Shuang_Xi_Traditional.png?v=1747370959",
  },
  {
    name: "Thank you for celebrating with us",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/thank-you-for-celebrating-with-us.png?v=1694483708",
  },
  {
    name: "Guo Jing & Huang Rong",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/GuoJing_HuangRong_wedding_sample.png?v=1747370320",
  },
  {
    name: "Romeo & Juliet",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Romeo_Juliet_wedding_sample.png?v=1747370320",
  },
  {
    name: "Juliana & Alberto",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Juliana_Alberto_wedding_sample.png?v=1747370320",
  },
  {
    name: "Jennifer & Ben",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/jennifer_ben_wedding_sample.png?v=1747370320",
  },
]

/* delete from Nov 25
const sipSnackHamperImageOptions = [
  {
    name: "Happy Birthday",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Happy_Birthday_Box.jpg?v=1755674333"
  },
  {
    name: "Congratulations",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Congratulations_Box.jpg?v=1755674333"
  },
  {
    name: "Thank You",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Thank_You_Box.jpg?v=1755070487",
  },
  {
    name: "Happy Snacking",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Happy_Snacking_Box_9f511cd1-1632-4652-977d-15c61ec18223.jpg?v=1755070487",
  },
];


const wellnessHamperImageOptions = [
  {
    name: "Stay Healthy Snack Happy",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Healthy_A.jpg?v=1755827000"
  },
  {
    name: "Live Healthy Happy",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Healthy_B.jpg?v=1755842385"
  },
  {
    name: "To Health and Happiness",
    url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Healthy_C.jpg?v=1755842386",
  },
];
*/

const hamperStickerOptions = [
  { name: "Design A", sku: "designA" },
  { name: "Design B", sku: "designB" },
  { name: "Design C", sku: "designC" },
  { name: "Design D", sku: "designD" },
];